import React, { useEffect, useState } from "react";
import {
  Text,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  Box,
  Button,
  Image,
} from "@chakra-ui/react";
import { BsTrash } from "react-icons/bs";
import { scrollBarStyle } from "../../../utils/helpers";
import { not } from "../../../assets/exports";

export const Notification = () => {
  const [isRinging, setIsRinging] = useState(false);

  useEffect(() => {
    setIsRinging(true);
  }, []);

  return (
    <Popover>
      <PopoverTrigger>
        <Button
          bg="transparent"
          boxShadow="unset"
          position={"relative"}
          _hover={{ outline: "none" }}
          _active={{ outline: "none" }}
          className={`bell-icon ${isRinging ? "ringing" : ""}`}
          _focus={{ outline: "none" }}
        >
          <Image src={not} minW="30px" minH="35px" />
          <Box
            bg="orangeColor"
            p={".1rem"}
            borderRadius="50%"
            h="19px"
            w="14px"
            position={"absolute"}
            top={"0.5"}
            fontSize={"12px"}
            ml={"4"}
          >
            0
          </Box>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        borderRadius="10px"
        h="30vh"
        mr={5}
        bg="#fff"
        boxShadow="lg"
      >
        <PopoverHeader>
          <Flex
            borderBottom="1px solid #7B47CC"
            pb={2}
            alignItems="center"
            justifyContent="space-between"
          >
            <Text size="sm">Notification</Text>
            <BsTrash cursor={"pointer"} color="red" />
          </Flex>
        </PopoverHeader>
        <PopoverBody sx={scrollBarStyle} overflowY={"scroll"} height={"250px"}>
          No notifications at the moment
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
